<template lang="pug">
section.section.search-results
  .container
    main.columns.is-multiline
      .content.column.is-12
        h1 {{ $t('search.search') }}&#0032;
          span.has-text-weight-light(v-if="query") {{ $t('search.for') }} »{{ queryString }}«
        p(v-if="query")
          i18n(path="search.hits")
            strong.has-text-weight-semibold(place="hit") {{ total }} {{ $tc('search.hit', total) }}

      .column.is-12
        .columns
          search-facets(:type="'aside'")
          .column.is-9
            search-form(v-bind:isHomepage="false" v-bind:permanent="true")

            .results(v-for="result, ri in results" :key="ri")
              article.media.is-block-mobile
                figure.media-left
                  p.image.is-128x128
                    a(@click="toResult(result)")
                      img(:src="imgSrc(result)")
                .media-content.content
                  a(@click="toResult(result)")
                    h2.is-size-2(v-html="$options.filters.formatStrikethrough(result.title)")
                    p
                      span(v-for="snippet in result.kwicText" v-html="snippet + '<br/>'")
                    p
                      small.has-text-grey-light {{ result.volume }} / {{ result.section | getLowestLevelSection }}
            div.results.has-text-centered(v-if="results.length < total")
              a.pagination-next(@click="nextQuery") {{ $t('search.furtherResults') }}
              a.pagination-next(@click="completeQuery") {{ $t('search.allResults', { resultcount: total }) }}
            .notification.is-info.results(v-if="query && results.length == 0")
              p {{ $t('search.noResults') }}
</template>

<script>
const { formatStrikethrough } = require("../../filters/formatStrikeThrough");
const { mapActions, mapState } = require("vuex");
const { messages } = require("../../i18n/search");

export default {
    name: "SearchResults",

    components: {
        SearchFacets: require("./SearchFacets"),
        SearchForm: require("./SearchForm"),
    },

    i18n: { messages },

    computed: {
        queryString() {
            return this.$route.query.q;
        },

        ...mapState("search", [
            "context",
            "query",
            "results",
            "total",
            "transactions",
        ]),
    },

    filters: {
        formatStrikethrough,

        getLowestLevelSection: function (sections) {
            if (sections) {
                return sections
                    .reduce((a, b) => {
                        let c = b > a ? b : a;
                        return c;
                    }, sections[0])
                    .substring(2);
            } else {
                return "";
            }
        },
    },

    methods: {
        ...mapActions("search", ["completeQuery", "newQuery", "nextQuery"]),

        imgSrc({ id }) {
            return `/iiif/3/${id}/square/128,128/0/default1.jpg`;
        },

        toResult({ id }) {
            //const { section } = this;
            const section = "suche";
            this.$router.push(`/seite/${section}/${id}`);
        },
    },

    props: ["section"],

    watch: {
        $route(to, from) {
            if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
                this.newQuery(this.$route);
            }
        },
    },

    created() {
        if (this.$route.query && this.$route.query.q) {
            this.newQuery(this.$route);
        }
    },
};
</script>
